import BibliographySearchResultsOption, {
  InputBibliographySearchResultsOption,
  defaultInputBibliographySearchResultsOption
} from './BibliographySearchResultsOption.vue'

export {
  BibliographySearchResultsOption,
  InputBibliographySearchResultsOption,
  defaultInputBibliographySearchResultsOption
}
